import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../../common/FormRenderer";
import { getValue } from "../../../../../utils/common";
import { GetActionTitle } from "../../Master.constants";

function DepartmentDetails({ action, record : data, onClose }: any) {

    const [department, setDepartment] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'company',
                label: 'Company',
                content: getValue(department, 'company.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'vertical',
                label: 'Vertical',
                content: getValue(department, 'vertical.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Department Name',
                content: getValue(department, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'shortCode',
                label: 'Department Code',
                styleClass: 'text-uppercase',
                content: getValue(department, 'shortCode')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'description',
                label: 'Description',
                content: getValue(department, 'description')
            }
        ]
    };

    useEffect(() => {
        if (data) {
            const { vertical } = data || {};
            const { id, name, company } = vertical || {};
            setDepartment({
                ...department,
                ...data,
                company: company && company.id ? { value: company.id, label: company.name } : null,
                vertical: id ? { value: id, label: name } : null
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Department', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={department}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                        <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>

                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DepartmentDetails;